/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useState } from 'react'
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Anchor, Button, Card } from '@nexigendigital/nxui'
import { useGetSecurityQuery } from 'api/account'
import { useAppSelector } from 'store/hooks'
import { WEIGHT } from 'helpers/constants'

/**********************************************************************************************************
 *   LIGHTBOXES
 **********************************************************************************************************/
import CloseAccountLightbox from 'containers/account/lightbox/closeAccountLightbox'
import ChangePasswordLightbox from 'containers/account/lightbox/changePasswordLightbox'
import EndActiveSessionLightbox from 'containers/account/lightbox/endActiveSessionLightbox'
import ChangeSecurityQuestionLightbox from 'containers/account/lightbox/changeSecurityQuestionLightbox'

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const SecurityCard = {
    Card: styled(Card)`
        width: 100%;
        margin-bottom: 0;
        border-radius: 0 0 16px 16px;

        header {
            border-radius: 0;
        }
    `,
    Footer: styled.div`
        display: flex;
        justify-content: flex-end;
        width: 100%;
        padding: 10px;
        border-top: 1px solid ${props => (props.theme['gray--100'])};
    `,
    Details: styled.p`
        font-weight: ${WEIGHT.MEDIUM};
        color: ${props => (props.theme['text--300'])};
    `
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Security() {
    const [lightbox, setLightbox] = useState({
        status: false,
        template: ''
    })
    const { isLoading } = useGetSecurityQuery()

    const { appSession: { user } } = useAppSelector((state) => state.app)
    const { security_question: securityQuestion } = user!

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <>
            <SecurityCard.Card
                table={{
                    conditions: {
                        loading: (isLoading) && 'Loading Security Information...'
                    },
                    render: {
                        columns: () => [
                            {
                                Header: 'Security',
                                accessor: 'security'
                            }, {
                                Header: '',
                                accessor: 'details'
                            }, {
                                Header: '',
                                accessor: 'action'
                            }
                        ],
                        data: () => [
                            {
                                security: 'Security Question',
                                details: <SecurityCard.Details>{securityQuestion.question}</SecurityCard.Details>,
                                action: (
                                    <Anchor color={'primary'} onClick={() => setLightbox({
                                        status: true,
                                        template: 'question'
                                    })}>Edit</Anchor>
                                )
                            }, {
                                security: 'Password',
                                details: <SecurityCard.Details>**********</SecurityCard.Details>,
                                action: (
                                    <Anchor color={'primary'} onClick={() => setLightbox({
                                        status: true,
                                        template: 'password'
                                    })}>Edit</Anchor>
                                )
                            }
                        ]
                    }
                }}
                footer={
                    <SecurityCard.Footer>
                        <Button color={'secondary'} onClick={() => setLightbox({ status: true, template: 'close' })}>
                            Close Account
                        </Button>
                        <Button color={'primary'} onClick={() => setLightbox({ status: true, template: 'end' })}>
                            End Active Sessions
                        </Button>
                    </SecurityCard.Footer>
                }
            />
            <ChangeSecurityQuestionLightbox
                status={lightbox.status && lightbox.template === 'question'}
                close={() => setLightbox({ status: false, template: '' })}
            />
            <CloseAccountLightbox
                status={lightbox.status && lightbox.template === 'close'}
                close={() => setLightbox({ status: false, template: '' })}
            />
            <EndActiveSessionLightbox
                status={lightbox.status && lightbox.template === 'end'}
                close={() => setLightbox({ status: false, template: '' })}
            />
            <ChangePasswordLightbox
                status={lightbox.status && lightbox.template === 'password'}
                close={() => setLightbox({ status: false, template: '' })}
            />
        </>
    )
}
